import {
  TextField as MuiTextField,
  TextFieldProps as MuiTextFieldProps,
} from "@mui/material";
import { styled } from "@mui/material/styles";

export type TextFieldProps = Omit<
  MuiTextFieldProps,
  "InputLabelProps" | "margin" | "fullWidth" | "variant" | "color" | "size" | "minRows"
> & {
  name: string;
};

const Input = styled(MuiTextField)(({ theme }) => ({
  "& .MuiFormLabel-root.MuiInputLabel-root": {
    color: theme.palette.text.primary,
  },

  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: '4px',
  },

  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":{
    borderColor: theme.palette.primary.light,
    borderWidth: 1,
  },

  "& .Mui-error": {
    borderColor: theme.palette.error.main,
    backgroundColor: theme.palette.primary.main,

    "&.MuiFormHelperText-root": {
      background: "none",
    },
  },

  "& .MuiInputBase-multiline": {
    display: "flex",
    flexDirection: "column",

    "& .MuiInputBase-inputMultiline": {
      marginBottom: theme.spacing(1),
    },
  },
}));

const TextField = ({ name, multiline, id, ...rest }: TextFieldProps) => {
  return (
      <Input
        id={id || name}
        fullWidth
        name={name}
        // size="small"
        multiline={multiline}
        minRows={multiline && !rest.rows ? 5 : undefined}
        {...rest}
        InputProps={rest.InputProps}
      />
  );
};

export default TextField;
